export default "__VITE_ASSET__DX6ZCpbN__"